import { LeaderboardTable } from '@/components/leaderboard-table';
import { InviteFriendsModal } from '@/components/modals/invite-friends-modal';
import { RestrictedWallet } from '@/components/restricted-wallet';
import { LeaderboardRecordCategory } from '@/constants/shared';
import { useAuth } from '@/hooks/useAuth';
import { useCurrentUserData } from '@/hooks/useCurrentUserData';
import { useLeaderboardData } from '@/hooks/useLeaderboard';
import { Box, Card, Flex, Heading, Image, Text, VStack } from '@chakra-ui/react';
import { useSearchParams } from 'react-router';
import goonSvgPath from '/assets/season/goon.svg';

export const Leaderboard = () => {
  const { isAuthenticated, address } = useAuth();
  const [searchParams] = useSearchParams();
  const overrideDay1Override = searchParams.get('overrideDay1Override') === 'true';
  const doLeaderboardPreview = searchParams.get('preview') === 'true';
  const { leaderboard, hasNextPage, fetchNextPage, isLoadingLeaderboard } = useLeaderboardData(
    LeaderboardRecordCategory.Leaderboard,
    undefined,
    overrideDay1Override,
    doLeaderboardPreview,
  );
  const { currentUserData, isLoading } = useCurrentUserData();

  return (
    <Box mb={6} fontFamily="Lufga, sans-serif">
      <Flex
        flexDirection={['column', 'row']}
        gap={2}
        justifyContent={'space-between'}
        alignItems={['flex-start', 'center']}
        mb={4}
      >
        <Box>
          <Heading size="4xl" color="#111111" textAlign={'left'} mb={2} fontWeight="700">
            Plume Portal Leaderboard
          </Heading>
          {isAuthenticated && (
            <Text color="#111111" fontWeight="500" mb={2} fontSize="lg" letterSpacing={-0.5}>
              Compare how you stand against other Plume Goons
            </Text>
          )}
          <Text color="#747474" fontWeight="500" lineHeight="1" fontSize="lg" letterSpacing={-0.5}>
            Leaderboard updates daily at midnight UTC
          </Text>
        </Box>
        <Box>
          <InviteFriendsModal />
        </Box>
      </Flex>
      <RestrictedWallet address={address!} mt={10} />
      {!isLoadingLeaderboard && !leaderboard?.length ? (
        <Card.Root rounded="16px" p={6} bg="bg" w="full" py={{ base: '98px', md: '110px' }}>
          <Card.Body>
            <VStack gap={4} justifyContent="center" alignItems="center">
              <Box p={1} bg="#E7E7E7" rounded="full" overflow="hidden">
                <Image src={goonSvgPath} opacity={0.7} boxSize={12} mb={-1} />
              </Box>
              <VStack gap={2} textAlign="center">
                <Heading fontSize="2xl" fontWeight="700" lineHeight="32px">
                  Welcome to the Plume Portal
                </Heading>
                <Heading fontSize="lg" fontWeight="500" color="text.secondary">
                  Track your position in the leaderboard starting from Day 2 of Plume Genesis
                </Heading>
              </VStack>
            </VStack>
          </Card.Body>
        </Card.Root>
      ) : (
        <LeaderboardTable
          leaderboard={leaderboard}
          recordType={LeaderboardRecordCategory.Leaderboard}
          hasNextPage={hasNextPage}
          fetchNextPage={fetchNextPage}
          currentUserData={currentUserData}
          isLoading={isLoading}
        />
      )}
    </Box>
  );
};
